var _style, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSrpGray(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_10",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 500 500",
    style: {
      enableBackground: "new 0 0 500 500"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#A1A1A1;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M454,429.1H46c-2.8,0-5,2.2-5,5v19.9c0,2.8,2.2,5,5,5h408c2.8,0,5-2.2,5-5v-19.9 C459,431.3,456.8,429.1,454,429.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M193.7,419.6c-0.9,2.6,1.1,5.3,3.8,5.3c35,0,70,0,104.9,0c2.7,0,4.7-2.7,3.8-5.3 c-12.9-38-19.5-76.7-22.3-114.7c-0.2-2.1-1.9-3.7-4-3.7c-20,0-39.9,0-59.9,0c-2.1,0-3.8,1.6-4,3.7 C213.2,342.9,206.6,381.6,193.7,419.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M217,292.1c-0.2,2.3,1.6,4.4,4,4.4c19.3,0,38.6,0,58,0c2.4,0,4.2-2,4-4.4c-0.3-3.6-0.7-7.2-0.8-10.8 c-0.1-2.2-1.8-3.9-4-3.9c-18.8,0-37.6,0-56.3,0c-2.2,0-3.9,1.7-4,3.9C217.7,284.9,217.4,288.6,217,292.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M351.5,142.1c1.4,2.4,4.4,3.2,6.8,1.8l43.3-25c2.4-1.4,3.2-4.4,1.8-6.8l-40-69.3c-1.4-2.4-4.4-3.2-6.8-1.8 l-43.3,25c-2.4,1.4-3.2,4.4-1.8,6.8L351.5,142.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M380,425c2.8,0,5-2.2,5-5V133.2l-10,5.8v281C375,422.8,377.2,425,380,425z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 250,
    cy: 154,
    r: 25
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 120,
    cy: 231,
    r: 20
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M144,231c0,0.7,0,1.4-0.1,2.1l92.6-53.4c-9.2-4.9-15.5-14.5-15.5-25.6c0,0,0-0.1,0-0.1l-93.8,54.2 C136.9,211.2,144,220.3,144,231z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M279,154c0,0.4,0,0.7,0,1.1l56.6-32.7l-15-26l-56.1,32.4C273.1,133.9,279,143.3,279,154z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M222.5,273h54.9c2.3,0,4.2-2,4-4.3c-2.3-27.2-3.3-54.5-3.2-81.7c0-2.2-1.8-4-4-4h-35.5l-0.2,0.1l-14.7,8.5 c-1.2,0.7-2,2-2,3.4c-0.1,24.5-1.2,49.1-3.2,73.7C218.4,271,220.2,273,222.5,273z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M75,425h90c2.8,0,5-2.2,5-5v-90c0-2.8-2.2-5-5-5h-25c0-11-9-20-20-20s-20,9-20,20H75c-2.8,0-5,2.2-5,5v90 C70,422.8,72.2,425,75,425z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M115,301.5c1.6-0.3,3.3-0.5,5-0.5s3.4,0.2,5,0.5v0V288h5c1.4,0,2.6-0.6,3.5-1.5c0.3-0.3,0.6-0.7,0.8-1.1 c0.4-0.7,0.6-1.5,0.6-2.4v0v-33.3c-0.5,0.4-1,0.8-1.6,1.2c-3.8,2.6-8.4,4.1-13.4,4.1c-5.7,0-10.9-2-15-5.3v0V283v0c0,2.8,2.2,5,5,5 h5V301.5L115,301.5z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSrpGray);
export default __webpack_public_path__ + "static/media/SRPGray.130fd3cbc653464856fb25f18ac70c01.svg";
export { ForwardRef as ReactComponent };